export default __webpack_public_path__ + "static/media/1190a6fb9d05616eab99c63a2711c07d.svg";